module.exports = __webpack_public_path__ + "streamline-24px-filled-in.5dbe18970cd573ac2f71.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/assets/fonts/streamline/streamline-24px-filled-in.eot
// module id = ../../../../../src/assets/fonts/streamline/streamline-24px-filled-in.eot
// module chunks = styles